import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.54248 0.910955L5.86066 4.59277L9.54248 8.27459L8.7243 9.09277L5.04207 5.41055L1.36066 9.09277L0.54248 8.27459L4.22389 4.59236L0.54248 0.910955L1.36066 0.0927734L5.04248 3.77459L8.7243 0.0927734L9.54248 0.910955Z",
		fill: "#545E6B"
	})]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
